import { Component, Input } from '@angular/core';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { ArchiveCatalog } from 'src/app/modules/shared/models/archive/archive-catalog.model';
import { ArchiveFileTitleRuleFormInfoType } from 'src/app/modules/shared/models/archive/archive-file-title-rule-form-info-type.enum';
import { ArchiveFileTitleRuleFormInfo } from 'src/app/modules/shared/models/archive/archive-file-title-rule-form-info.model';
import { ArchiveFileTitleRule } from 'src/app/modules/shared/models/archive/archive-file-title-rule.model';
import { ArchiveTitleRuleItemInfo } from 'src/app/modules/shared/models/archive/archive-title-rule-item-info.model';
import { ArchiveTitleRuleItemParamInfo } from 'src/app/modules/shared/models/archive/archive-title-rule-item-param-info.model';
import { ArchiveTitleRuleItemParamType } from 'src/app/modules/shared/models/archive/archive-title-rule-item-param-type.enum';
import {
  ArchiveTitleRuleItemDisplayType,
  ArchiveTitleRuleItemType,
} from 'src/app/modules/shared/models/archive/archive-title-rule-item-type.enum';
import { ArchiveVolumeCreateType } from 'src/app/modules/shared/models/archive/archive-volume-create-type.enum';
import { ArchiveVolumeRule } from 'src/app/modules/shared/models/archive/archive-volume-rule.model';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { ArchiveFileTitleRuleService } from 'src/app/modules/shared/services/archive-file-title-rule.service';

@Component({
  selector: 'app-dialog-projects-profiles-volumn-title-rule-wbs',
  templateUrl:
    './dialog-projects-profiles-volumn-title-rule-wbs.component.html',
  styleUrls: [
    './dialog-projects-profiles-volumn-title-rule-wbs.component.scss',
  ],
})
export class DialogProjectsProfilesVolumnTitleRuleWbsComponent {
  @Input()
  data!: DialogConfig<ArchiveCatalog>;

  editing: { [name: string]: boolean } = {};

  catalog: ArchiveCatalog = new ArchiveCatalog();

  record = new ArchiveFileTitleRule();

  ArchiveVolumeCreateType = ArchiveVolumeCreateType;

  ruleItemMap: { [key: string]: ArchiveTitleRuleItemParamInfo } = {};

  ArchiveTitleRuleItemType = ArchiveTitleRuleItemType;

  ArchiveTitleRuleItemParamType = ArchiveTitleRuleItemParamType;

  exampleName = '';

  forceUpdate = true;

  constructor(
    private archiveFileTitleRuleService: ArchiveFileTitleRuleService,
    private globalService: GlobalService
  ) {}

  fileTitleRuleFormInfosCode: ArchiveFileTitleRuleFormInfo = {
    type: ArchiveFileTitleRuleFormInfoType.FORM_CODE,
    checked: false,
    separator: '',
  };

  fileTitleRuleFormInfosName: ArchiveFileTitleRuleFormInfo = {
    type: ArchiveFileTitleRuleFormInfoType.FORM_NAME,
    checked: false,
    separator: '',
  };

  fileTitleRuleFormInfosSn: ArchiveFileTitleRuleFormInfo = {
    type: ArchiveFileTitleRuleFormInfoType.FORM_SN,
    checked: false,
    separator: '',
  };

  ngOnInit() {
    this.handleDataBeforeInit(this.data.data!);
  }

  genExampleName() {
    console.log('generate example name: ', this.ruleItemMap);
    setTimeout(() => {
      let exampleName = '';
      for (const mainType of Object.keys(ArchiveTitleRuleItemType)) {
        for (const paramType of Object.keys(ArchiveTitleRuleItemParamType)) {
          let part = '';
          if (paramType === ArchiveTitleRuleItemParamType.ITEM_NAME) {
            switch (mainType) {
              case ArchiveTitleRuleItemType.PROJECT:
                part = '104国道杭州河庄至衙前段';
                break;
              case ArchiveTitleRuleItemType.DESIGN:
                part = '杭州市交通规划设计研究院有限公司';
                break;
              case ArchiveTitleRuleItemType.SUPERVISION:
                part = '杭州交通工程监理咨询有限公司';
                break;
              case ArchiveTitleRuleItemType.CONSTRUCTION:
                part = '浙江交工集团股份有限公司';
                break;
              case ArchiveTitleRuleItemType.SPOT_CHECK:
                part = '杭州市交通工程试验检测中心有限公司';
                break;
              case ArchiveTitleRuleItemType.JG_CHECK:
                part = '中路高科交通检测检验认证有限公司';
                break;
              case ArchiveTitleRuleItemType.COMPLETED_CHECK:
                part = '绍兴市交科工程检测有限公司';
                break;
              case ArchiveTitleRuleItemType.DW:
                part = '主线高架桥(K4+658.396-K6+163.539)';
                break;
              case ArchiveTitleRuleItemType.FB:
                part = '基础及下部构造（188#~200#墩）';
                break;
              case ArchiveTitleRuleItemType.SUB_FB:
                part = '188#墩基础';
                break;
              case ArchiveTitleRuleItemType.FX:
                part = '钻孔灌注桩';
                break;
              case ArchiveTitleRuleItemType.SECTION:
                part = '188-1#桩基';
                break;
              default:
                part = '';
                break;
            }
          } else {
            switch (mainType) {
              case ArchiveTitleRuleItemType.DESIGN:
                part = 'SJ-01';
                break;
              case ArchiveTitleRuleItemType.SUPERVISION:
                part = 'XSJL-01';
                break;
              case ArchiveTitleRuleItemType.CONSTRUCTION:
                part = 'EPC-02';
                break;
              case ArchiveTitleRuleItemType.SPOT_CHECK:
                part = 'SY-01';
                break;
              case ArchiveTitleRuleItemType.JG_CHECK:
                part = 'JGJC-01';
                break;
              case ArchiveTitleRuleItemType.COMPLETED_CHECK:
                part = 'JG-01';
                break;
              case ArchiveTitleRuleItemType.DW:
                part = 'Q01';
                break;
              case ArchiveTitleRuleItemType.FB:
                part = '01';
                break;
              case ArchiveTitleRuleItemType.SUB_FB:
                part = '02';
                break;
              case ArchiveTitleRuleItemType.FX:
                part = '03';
                break;
              case ArchiveTitleRuleItemType.SECTION:
                part = '04';
                break;
              case ArchiveTitleRuleItemType.SEGMENT:
                part = 'D1';
                break;
              case ArchiveTitleRuleItemType.LAYER:
                part = 'C1';
                break;
              default:
                part = '';
                break;
            }
          }
          const key = `${mainType}_${paramType}`;
          if (!!this.ruleItemMap[key] && !!this.ruleItemMap[key].checked) {
            if (!!this.ruleItemMap[key].separator) {
              part += this.ruleItemMap[key].separator;
            }
            exampleName += part;
          }
        }
      }
      this.exampleName = `${this.record.titleFixedPrefix ?? ''}${exampleName}${
        this.record.titleFixedSuffix ?? ''
      }`;

      if (this.fileTitleRuleFormInfosCode.checked) {
        this.exampleName += 'GL105' + this.fileTitleRuleFormInfosCode.separator;
      }
      if (this.fileTitleRuleFormInfosName.checked) {
        this.exampleName +=
          '分项工程检验申请和中间交验审批批表' +
          this.fileTitleRuleFormInfosName.separator;
      }
      if (this.fileTitleRuleFormInfosSn.checked) {
        this.exampleName +=
          '20250610001' + this.fileTitleRuleFormInfosSn.separator;
      }

      // 不要删。下面这段代码是为了确保变更检测机制能检测到titleRule的变化，从而更新界面显示的值。
      const titleAutoParts: Array<ArchiveTitleRuleItemInfo> = [];
      for (const mainType of Object.keys(ArchiveTitleRuleItemType)) {
        const info = new ArchiveTitleRuleItemInfo();
        info.type = mainType as ArchiveTitleRuleItemType;
        info.params = [];
        for (const paramType of Object.keys(ArchiveTitleRuleItemParamType)) {
          const key = `${mainType}_${paramType}`;
          if (!!this.ruleItemMap[key] && this.ruleItemMap[key].checked) {
            info.params.push(this.ruleItemMap[key]);
          } else {
            info.params.push({
              checked: false,
              type: paramType as ArchiveTitleRuleItemParamType,
            });
          }
        }
        if (info.params.length > 0) {
          titleAutoParts.push(info);
        }
      }
      this.record.titleAutoParts = titleAutoParts;
    }, 50);
  }

  private handleDataBeforeInit(response: ArchiveCatalog) {
    this.catalog = JSON.parse(JSON.stringify(response)) as ArchiveCatalog;
    for (const mainType of Object.keys(ArchiveTitleRuleItemDisplayType)) {
      if (
        mainType.includes('MATERIAL') ||
        mainType.includes('DATE') ||
        mainType.includes('FORM_FREE_HEAD')
      ) {
        continue;
      }
      for (const paramType of Object.keys(ArchiveTitleRuleItemParamType)) {
        const key = `${mainType}_${paramType}`;
        this.ruleItemMap[key] = new ArchiveTitleRuleItemParamInfo();
        this.ruleItemMap[key].mainType =
          ArchiveTitleRuleItemDisplayType[
            mainType as keyof typeof ArchiveTitleRuleItemDisplayType
          ];
        this.ruleItemMap[key].type =
          ArchiveTitleRuleItemParamType[
            paramType as keyof typeof ArchiveTitleRuleItemParamType
          ];
      }
    }
    delete this.ruleItemMap[
      `${ArchiveTitleRuleItemType.PROJECT}_${ArchiveTitleRuleItemParamType.ITEM_SN}`
    ];
    delete this.ruleItemMap[
      `${ArchiveTitleRuleItemType.SEGMENT}_${ArchiveTitleRuleItemParamType.ITEM_NAME}`
    ];
    delete this.ruleItemMap[
      `${ArchiveTitleRuleItemType.LAYER}_${ArchiveTitleRuleItemParamType.ITEM_NAME}`
    ];
    this.archiveFileTitleRuleService
      .findOne({
        catalogId: this.catalog.id!,
      })
      .subscribe((res: ArchiveVolumeRule) => {
        if (res) {
          this.record = res;
          for (const item of this.record.titleAutoParts ?? []) {
            for (const param of item.params ?? []) {
              const key = `${item.type}_${param.type}`;
              if (!!this.ruleItemMap[key]) {
                this.ruleItemMap[key].checked = param.checked;
                this.ruleItemMap[key].separator = param.separator;
              }
            }
          }
          for (const formInfo of this.record.fileTitleRuleFormInfos ?? []) {
            switch (formInfo.type) {
              case ArchiveFileTitleRuleFormInfoType.FORM_CODE:
                this.fileTitleRuleFormInfosCode = formInfo;
                break;
              case ArchiveFileTitleRuleFormInfoType.FORM_NAME:
                this.fileTitleRuleFormInfosName = formInfo;
                break;
              case ArchiveFileTitleRuleFormInfoType.FORM_SN:
                this.fileTitleRuleFormInfosSn = formInfo;
                break;
            }
          }
          setTimeout(() => {
            this.genExampleName();
          }, 100);
        }
      });
  }

  isNaN(content: number) {
    return window.isNaN(content);
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    this.submit();
  }

  get canConfirm() {
    return true;
  }

  private submit() {
    const titleAutoParts: Array<ArchiveTitleRuleItemInfo> = [];
    for (const mainType of Object.keys(ArchiveTitleRuleItemType)) {
      const info = new ArchiveTitleRuleItemInfo();
      info.type = mainType as ArchiveTitleRuleItemType;
      info.params = [];
      for (const paramType of Object.keys(ArchiveTitleRuleItemParamType)) {
        const key = `${mainType}_${paramType}`;
        if (!!this.ruleItemMap[key] && this.ruleItemMap[key].checked) {
          info.params.push(this.ruleItemMap[key]);
        } else {
          info.params.push({
            checked: false,
            type: paramType as ArchiveTitleRuleItemParamType,
          });
        }
      }
      if (info.params.length > 0) {
        titleAutoParts.push(info);
      }
    }
    this.record.titleAutoParts = titleAutoParts;
    this.record.forceUpdate = this.forceUpdate;
    if (!this.record.id) {
      this.record.catalogId = this.catalog.id!;
      this.record.projectId = this.globalService.projectId;
      this.record.fileTitleRuleFormInfos = [
        this.fileTitleRuleFormInfosCode,
        this.fileTitleRuleFormInfosName,
        this.fileTitleRuleFormInfosSn,
      ];
      this.archiveFileTitleRuleService
        .create(this.record)
        .subscribe((response) => {
          if (response) {
            this.data.onConfirm!();
          }
        });
    } else {
      this.record.fileTitleRuleFormInfos = [
        this.fileTitleRuleFormInfosCode,
        this.fileTitleRuleFormInfosName,
        this.fileTitleRuleFormInfosSn,
      ];
      this.archiveFileTitleRuleService
        .update(this.record)
        .subscribe((response: boolean) => {
          if (response) {
            this.data.onConfirm!();
          }
        });
    }
  }
}
